import { SET_CMS_RESOURCE, SetCmsResourceAction } from './actions';
import { CmsState } from './types';

const initialState: CmsState = {
	modals: [],
	lastFetched: null,
};

type CmsAction = SetCmsResourceAction;

export default function cmsReducer(state = initialState, action: CmsAction): CmsState {
	if (action.type === SET_CMS_RESOURCE) {
		const { modals, lastFetched } = action.payload;
		return {
			...state,
			modals,
			lastFetched,
		};
	}
	return state;
}
